module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.ec6dacbfdf4e1921d68f.js");
};